import { useTranslation } from 'react-i18next';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { SubmissionModeContainer } from './ReportSubmissionMode.styles';

export const ReportSubmissionMode = (props: {
  submissionMode: string | null | undefined;
}) => {
  const { t } = useTranslation();
  const { submissionMode } = props;
  if (!submissionMode) {
    return null;
  }

  const icon = getSubmissionIcon(submissionMode);

  return (
    <SubmissionModeContainer>
      <StyledIcon className={icon} size="20px" />
      {t(`reporting.ReportCard.submissionModeVia`, {
        submissionMode:
          submissionMode === 'Hub Reporting' ? 'Manual Intake' : submissionMode,
      })}
    </SubmissionModeContainer>
  );
};

const getSubmissionIcon = (submissionMode: string) => {
  if (submissionMode.includes('App')) {
    return 'uil-mobile-android';
  } else if (submissionMode.includes('Vault Talk')) {
    return 'uil-phone';
  } else if (submissionMode.includes('Slack')) {
    return 'uil-slack';
  } else {
    return 'uil-file';
  }
};
